export default __webpack_public_path__ + "static/media/close-icon-white.64508911.svg";